import { useTranslation } from 'react-i18next';
import { LOCALES, isLocale } from '@/i18n';
import { LOCALE_NAMES, useLocalePreference } from '@/features/shell/useLocalePreference';

/**
 * Two words, not a globe icon with a dropdown of forty languages.
 *
 * Each language is written in itself — somebody looking for Spanish is looking
 * for the word "Español", not for "Spanish" in a language they do not read.
 *
 * The saving lives in `useLocalePreference`, shared with the phone's menu, so
 * the two switches cannot drift apart. They already did once: the choice reached
 * the browser and never the profile, and the weekly reminder kept arriving in
 * whatever language the account was created in.
 */
export function LanguageSwitch() {
  const { i18n } = useTranslation();
  const locale = useLocalePreference();
  const current = isLocale(i18n.language) ? i18n.language : 'en';

  return (
    <label className="flex items-center">
      <span className="sr-only">{LOCALE_NAMES[current]}</span>
      <select
        value={current}
        onChange={(e) => {
          if (isLocale(e.target.value)) locale.change(e.target.value);
        }}
        className="min-h-tap rounded border border-line bg-paper px-2 text-caption text-leaf-soft"
      >
        {LOCALES.map((value) => (
          <option key={value} value={value}>
            {LOCALE_NAMES[value]}
          </option>
        ))}
      </select>
    </label>
  );
}
